import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

// LegendContainer does not use props, so no type needed
export const LegendContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
});

// Props for Bullet
interface BulletProps {
  color?: string;
  loading?: boolean;
}

export const Bullet = styled("span", {
  shouldForwardProp: (prop) => prop !== "color" && prop !== "loading",
})<BulletProps>(({ theme, color, loading }) => ({
  height: "8px",
  width: "8px",
  backgroundColor: loading ? theme.palette.gray30.main : color,
  borderRadius: "50%",
  marginRight: "5px",
  marginTop: "10px",
}));

export const TextContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

export const ValueTypography = styled(Typography)({
  color: "#5E6366",
  fontSize: "24px",
  lineHeight: "30px",
});

export const LabelTypography = styled(Typography)({
  color: "#919699",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.44px",
  "&:first-letter": {
    textTransform: "capitalize",
  },
});

// Props for DividerContainer
interface DividerContainerProps {
  isMobile?: boolean;
}

export const DividerContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "isMobile",
})<DividerContainerProps>(({ isMobile }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: 21,
  paddingLeft: isMobile ? "0px" : "35px",
}));

// Props for Divider
interface DividerProps {
  loading?: boolean;
}

export const Divider = styled("div", {
  shouldForwardProp: (prop) => prop !== "loading",
})<DividerProps>(({ theme, loading }) => ({
  height: "1px",
  backgroundColor: loading ? theme.palette.gray30.main : "#C6CACC",
}));
